import React from 'react';

const PuzzleSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2 9.2c-1 0-1.9.5-2.3 1.3H16V5H9.5v3l.3.3c.1.1.2.4.2.7 0 .6-.5 1-1 1-.6 0-1-.5-1-1 0-.3.1-.5.3-.7l.3-.3V5H2v14h6.5v-2.9l-.3-.3c-.2-.2-.3-.5-.3-.8 0-.6.5-1 1-1 .6 0 1 .5 1 1 0 .3-.1.5-.3.7l-.3.3v3H16v-5.5h.9c.5.8 1.4 1.3 2.3 1.3 1.5 0 2.8-1.2 2.8-2.8 0-1.5-1.2-2.8-2.8-2.8m0 4.6c-.6 0-1.2-.3-1.5-.8l-.3-.5H15V18h-4.5v-1.6c.3-.4.6-.9.6-1.4 0-1.1-.9-2-2-2s-2 .9-2 2c0 .5.2 1 .6 1.4V18H3V6h4.5v1.6c-.3.3-.6.8-.6 1.4 0 1.1.9 2 2 2s2-.9 2-2c0-.5-.2-1-.6-1.4V6H15v5.5h2.4l.3-.5c.3-.5.9-.8 1.5-.8 1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8"
        />
    </svg>
);

PuzzleSvg.displayName = 'PuzzleSvg';
export default PuzzleSvg;
